import { Component, OnInit , Output, EventEmitter} from '@angular/core';
import { ApiService } from '../api.service';
import { Store } from '@ngrx/store';
import { GlobalService } from '../global.service';
import { Router } from "@angular/router";
import {ModalModule} from "ngx-modal";


@Component({
	selector: 'app-view-plans',
	templateUrl: './view-plans.component.html',
	styleUrls: ['./view-plans.component.scss']
})
export class ViewPlansComponent implements OnInit {

	tab: number = 1;
	resBroadband :any;
	isBroadband = true;

	show_popup:boolean = false;
	popup_image:any;
	url_popup:any;

	constructor(private globalService: GlobalService) { 
		this.globalService.deleteSession('NumberPhone')
		this.globalService.deleteSession('phoneSelecting')
		this.globalService.deleteSession('mainApplication')
		this.globalService.deleteSession('broad_plan')
	}
	ngOnInit() { 
		this.globalService.setSession('digi_type','');
		// console.log(this.globalService.getSession('digi_type'))
		this.show_popup = this.globalService.getSession('show_popup_frontpage') == 1;
        this.popup_image = this.show_popup ? this.globalService.getSession('popup_frontpage') : "";
		this.url_popup = this.show_popup ? this.globalService.getSession('link_popup_frontpage') : "#";
		console.log(this.globalService.getSession('show_popup_frontpage'));
		if(this.show_popup){
			let element:HTMLElement = document.getElementById('popup-frontpage-btn') as HTMLElement;
			element.click();
		}
	}

	getData($event){
		this.resBroadband = $event;
		
		$('.tab-item').removeClass('active')
		$('.tab-2').addClass('active');
		this.tab = 2;

	}
	destroyCarousel() {
		if ((<any>$)('.broadbrand-slider_mobile').hasClass('slick-initialized')) {
			(<any>$)('.broadbrand-slider_mobile').slick('destroy');
		}
	}

	clickTab(number: any) {

		$('.tab-item').removeClass('active')
		$('.tab-'+ number).addClass('active');

		if ($(window).outerWidth() <= 768) {
			$(window).on('ready', function () {
				(<any>$)(".view-plans-slider_mobile").not('.slick-initialized').slick({
					slidesToShow: 1,
					dots: true,
					infinite: false,
					centerMode: true,
					arrows: false,
					autoplay: true,
					autoplaySpeed:1500,
				});
				(<any>$)(".device-slider_mobile").not('.slick-initialized').slick({
					slidesToShow: 1,
					dots: true,
					infinite: false,
					centerMode: true,
					arrows: false,
					autoplay: true,
					autoplaySpeed:1500,
				});
				(<any>$)(".broadbrand-slider_mobile").not('.slick-initialized').slick({
					slidesToShow: 1,
					dots: true,
					infinite: false,
					centerMode: true,
					arrows: false,
					autoplay: true,
					autoplaySpeed:1500,
				});
			})
		}
		
		this.tab = number;
	}

	displayBroadband(item){
		if(item.length == 0){
			this.isBroadband = false
		}else{
			this.isBroadband = true
		}
	}

}
